<template>
  <div>
    <div v-if="localLoading && loadingText" class="text-center font-weight-bold">{{loadingText}}</div>
    <Spinner v-if="localLoading" />
    <NotificationBar v-if="localLoadingError" type="error">
      <NotificationBarTitle>{{localLoadingError}}</NotificationBarTitle>
    </NotificationBar>
  </div>
</template>

<script>
export default {
  name: 'LoadingPanel',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: String,
    loadingError: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localLoading: this.$props.loading,
      localLoadingError: this.$props.loadingError
    }
  },
  watch: {
    loading: function() {
      this.localLoading = this.$props.loading
    },
    loadingError: function() {
      this.localLoadingError = this.$props.loadingError
    }
  },
  methods: {
    startLoading() {
      this.localLoading = true
      this.localLoadingError = ''
      this.$emit('update', this.localLoading)
    },
    finishedLoading() {
      this.localLoading = false
      this.$emit('update', this.localLoading)
    },
    setError(title, errorInfo) {
      this.localLoadingError = title
      // TODO: In future will process error info details for a better display
    }
  }
}
</script>